<template>
  <div id="bank-slip-success-page">
    <div class="success-page__header">
      <img :src="iconSuccessURL" alt="Sucesso!">
      <h2>Seu boleto foi gerado com sucesso</h2>

      <p>
        <strong>
          Você tem {{ device.payment.isRenovation ? '1 dia útil' : 'até 3 dias úteis' }} para efetuar o pagamento.
        </strong>

        <br />

        Após o débito em nosso sistema, enviaremos uma confirmação para
        <strong>{{ emailString }}</strong> com todos os detalhes do
        serviço contratado. Em caso de não pagamento do boleto, a
        {{ device.payment.isRenovation ? 'renovação' : 'compra' }} será cancelada.
      </p>

      <p>
        <strong>Atenção:</strong> sempre verifique a sua caixa de spam,
        pois o e-mail pode ser direcionado para lá.
      </p>
    </div>

    <div class="success-page__content">
      <div class="success-page__block">
        <span class="icon icon__document">Boleto</span>

        <Button
          label="Visualizar boleto"
          @click.prevent.stop="clickToOpen(device.payment.url)"
        />

        <Button
          label="Copiar código de barras"
          icon="copy-purple"
          theme="purple"
          @click.prevent.stop="clickToCopy(device.payment.digitableLine, 'digitableLine')"
        />
      </div>

      <NPS />

      <div class="success-page__block">
        <h3>Resumo da {{ device.payment.isRenovation ? 'renovação' : 'compra' }}</h3>

        <div class="success-page__block__row">
          <p>
            <span>Subtotal:</span>
            <strong>{{ device.payment.amount | currencyBRL }}</strong>
          </p>
        </div>

        <div class="success-page__block__row row-footer">
          <p>
            <span>Valor Total:</span>
            <strong>{{ device.payment.amount | currencyBRL }}</strong>
          </p>
        </div>
      </div>

      <div class="success-page__block">
        <div class="success-page__accordion">
          <div class="success-page__accordion-head">
            <div class="success-page__accordion-head-title">
              <img :src="iconDeviceURL" alt="Aparelho">
              <span>{{ device.nome | capitalize }}</span>
            </div>

            <button v-if="isDesktop" @click.prevent.stop="toggleDetails" :class="{'opened': showDetails}">
              <span>Ver detalhes</span>
            </button>
          </div>

          <div v-if="showDetails" class="success-page__accordion-content">
            <div class="success-page__accordion-content-row">
              <img :src="iconCoverageURL" alt="Cobertura">
              <p>
                <strong>Cobertura: </strong>
                <span>Roubo</span>
                <span v-if="somenteRoubo"> e Furto</span>
                <span v-else>, Furto, Quebra, Líquido</span>
              </p>
            </div>

            <div class="success-page__accordion-content-row">
              <img :src="iconValidityURL" alt="Vigência">
              <p>
                <strong>Vigência do seguro: </strong>
                <span>12 meses (Franquia de 25% do valor do aparelho parcelada em até 4x)</span>
              </p>
            </div>

            <div v-if="device.payment.isRenovation" class="success-page__accordion-content-row">
              <img :src="iconCoverageURL" alt="Ícone documento">
              <p>
                <strong>{{ device.payment.isRenovation ? 'Seguro sem carência: ': 'Carência de 30 dias: '}}</strong>
                <span>Vigência iniciada em {{ device.renewalStartDate }}</span>
              </p>
            </div>

            <div v-if="hasProtectedBag" class="success-page__accordion-content-row">
              <img :src="iconCoverageURL" alt="Cobertura">
              <p>
                <strong>{{ device.protectedBag.bagName }} </strong>
                <span>(Transações digitais, pix e itens da bolsa)</span>
              </p>
              <a class="terms" :href="device.protectedBag.termsLink" target="_blank">
                <img class="terms__icon" :src="iconDocument" alt="Ícone documento">
                <span class="terms__title">Condições gerais</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="success-page__footer">
        <Button
          label="Continuar navegando"
          icon="chevron-left"
          theme="link"
          @click="$router.push('/')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/ui/Button'
import { mapState } from 'vuex'

import NPS from '@/components/NPS/index.vue'

export default {
  name: 'BankSlip',
  components: {
    Button,
    NPS
  },
  data () {
    return {
      showDetails: false,
      isDesktop: true
    }
  },
  computed: {
    ...mapState(['device']),
    somenteRoubo () {
      return this.device.somenteRoubo
    },
    iconSuccessURL () {
      return require(`@/assets/svg/icon-success-purple.svg`)
    },
    iconDeviceURL () {
      const name = this.device.deviceTypeName === 'celular' ? 'cellphone' : this.device.deviceTypeName
      return require(`@/assets/svg/icon-device-${name}.svg`)
    },
    iconCoverageURL () {
      return require(`@/assets/svg/icon-coverage-purple.svg`)
    },
    iconValidityURL () {
      return require(`@/assets/svg/icon-validity-purple.svg`)
    },
    iconDocument () {
      return require(`@/assets/svg/icon-document-purple.svg`)
    },
    emailString () {
      return this.device.personalData.email
        ? this.device.personalData.email
        : 'o e-mail de cadastro '
    },
    hasProtectedBag () {
      return !!this.device.protectedBag
    }
  },
  mounted () {
    const windowSize = window.innerWidth

    if (windowSize <= 768) {
      this.isDesktop = false
      this.showDetails = true
    }
  },
  methods: {
    clickToOpen (url) {
      return window.open(url, '_blank')
    },
    clickToCopy (text, action) {
      const actions = {
        digitableLine: ' O código de barras foi copiado para sua área de transferência.'
      }

      this.showToast('success', actions[action])
      return navigator.clipboard.writeText(text)
    },
    toggleDetails () {
      this.showDetails = !this.showDetails
    },
    showToast (icon, msg) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        }
      })

      Toast.fire({
        icon,
        title: msg
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../SuccessPage.scss';

#bank-slip-success-page {
  align-items: center;
  display: flex;
  flex-direction: column;

  .success-page__header {
    max-width: 752px;
    text-align: center;
    padding-top:32px;
    width: 100%;

    img {
      margin-bottom: 12px;
    }
  }

  .success-page__content {
    max-width: 944px;
    width: 100%;

    .success-page__block {
      align-items: center;
      flex-shrink: 0;
      flex-wrap: wrap;
      justify-content: flex-end;

      span {
        margin-right: auto;
      }

      button {
        margin-top: 16px;
        width: 100%;

        @media (min-width: 768px) {
          margin-left: 16px;
          margin-top: 0;
          width: fit-content;
        }
      }

      &__row {
        flex-shrink: 0;
        flex-wrap: wrap;

        p {
          display: flex;
          margin: 0;
          width: 100%;

          + p {
            margin-top: 12px;
          }

          span {
            color: #444444;
            font-family: Rubik, sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
          }

          strong {
            color: #444444;
            font-family: Rubik, sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 19px;
            margin-left: auto;
            text-align: right;
          }
        }
      }

      .success-page__accordion {
        width: 100%;

        &-head {
          align-items: center;
          display: flex;
          justify-content: space-between;
          margin-top: 10px;

          &-title {
            align-items: center;
            display: flex;
            justify-content: flex-start;

            img {
              margin-right: 16px;
              width: 32px;
            }

            span {
              color: #444444;
              font-family: Oscine, sans-serif;
              font-style: normal;
              font-weight: bold;
              font-size: 18px;
              line-height: 23px;
            }
          }

          button {
            &.opened {
              span {
                &::before {
                  transform: rotate(0);
                  transition: all ease 0.2s;
                }
              }
            }

            &:focus {
              outline:0;
            }

            span {
              display: inline-block;
              padding-right: 20px;
              position: relative;

              &::before {
                background-image: url(~@/assets/svg/chevron-up.svg);
                content: '';
                height: 7px;
                position: absolute;
                right: 0;
                top: calc(50% - 3.5px);
                transform: rotate(180deg);
                transition: all ease 0.2s;
                width: 14px;
              }
            }
          }
        }

        &-content {
          margin-top: 22px;

          &-row {
            align-items: center;
            border-top: solid 1px #BDC2C6;
            display: flex;
            padding: 20px 0;
            justify-content: flex-start;
            text-align: left;

            &:last-child {
              padding-bottom: 0;
            }

            img:not(.terms__icon) {
              margin-right: 16px;
              width: 32px;
            }

            p {
              margin: 0;

              span {
                color: #444444;
                font-family: Oscine, sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 21px;
              }

              strong {
                color: #444444;
                font-family: Oscine, sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 21px;
              }
            }
          }
        }
      }
    }

    .success-page__footer {
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 30px 0;
    }
  }

  .terms {
    margin-left: auto;
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #3F4956;

    @media (max-width: 959px) {
      font-size: 11px;
      flex-direction: column;
      text-align: center;
    }

    @media (max-width: 767px) {
      max-width: 67px;
    }

    &__icon {
      max-width: 20px;
      margin-right: 7px;

      @media (max-width: 959px) {
        margin-right: 0;
        margin-bottom: 3px;
      }
    }

    &__title {
      line-height: 1.1;
    }
  }

  .terms {
    margin-left: auto;
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #3F4956;

    @media (max-width: 959px) {
      font-size: 11px;
      flex-direction: column;
      text-align: center;
    }

    @media (max-width: 767px) {
      max-width: 67px;
    }

    &__icon {
      max-width: 20px;
      margin-right: 7px;

      @media (max-width: 959px) {
        margin-right: 0;
        margin-bottom: 3px;
      }
    }

    &__title {
      line-height: 1.1;
    }
  }
}
</style>
